import request from '@/utils/request'

let AuctionApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.auction.auction/index', data);
  },

  /*用户拍卖列表*/
  getAuctionList(data) {
    return request._post('/shop/plus.auction.auction/index', data);
  },
  PurchaseList(data) {
    return request._post('/shop/plus.auction.auction/Purchase', data);
  },
  /*添加*/
  addAuction(data) {
    return request._post('/shop/plus.auction.auction/add', data);
  },

  /*获取拍卖信息*/
  auctionDetail(data) {
    return request._post('/shop/plus.auction.auction/AuctionDetail', data);
  },
  /*编辑*/
  editAuction(data) {
    return request._post('/shop/plus.auction.auction/edit', data);
  },
  // /*删除*/
  deleteAuction(data) {
    return request._post('/shop/plus.auction.auction/index', data);
  },
  // /*删除*/
  getAuction(data) {
    return request._get('/shop/setting.auction/index', data);
  },
  // /*删除*/
  setAuction(data) {
    return request._post('/shop/setting.auction/index', data);
  },
}
export default AuctionApi;



// WEBPACK FOOTER //
// ./src/api/auction.js